// extracted by mini-css-extract-plugin
export default {"wrapper":"Background_wrapper__iikb+","background-video":"Background_background-video__mxEwZ"};